import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePages } from '../../context/PagesContext';
import styles from './Footer.module.scss';
import logo from '../../assets/img/logo.png';

const Footer: React.FC = () => {
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();

    const { data } = usePages();
    const companyName = data?.companyName ?? 'СТВ ДИЗАЙН';
    const companyDescription = data?.companyDescription ?? 'Премиальные услуги по строительству и ремонту коммерческой недвижимости.';

    const handleLogoClick = () => {
        navigate('/');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleAboutClick = (e: React.MouseEvent) => {
        e.preventDefault();
        if (window.location.pathname === '/about') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            navigate('/about');
        }
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.centerContent}>
                    <Link to="/" className={styles.logo} onClick={handleLogoClick}>
                        <img src={logo} alt={companyName} />
                    </Link>

                    <p className={styles.desc}>{companyDescription}</p>

                    <Link
                        to="/about"
                        className={styles.aboutButton}
                        onClick={handleAboutClick}
                    >
                        О компании
                    </Link>
                </div>

                <div className={styles.bottom}>
                    <p className={styles.copyright}>
                        ©{currentYear} {companyName}. Все права защищены
                    </p>
                    <p className={styles.metaDisclaimer}>
                        Meta Platforms Inc. (владелец Facebook и Instagram) — организация признана экстремистской, её деятельность запрещена на территории России
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
